var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MonthPressPurchaseList',{attrs:{"tabTitle":"하드웨어입고내역","materialType":"S0404","pType":"하드웨어"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }